import React, { useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import Validator from "../../services/Validator";
import Api from "../../services/ApiService";
import InfoStage from "./basicStages/InfoStage";
import UploadStage from "./basicStages/UploadStage";

const BasicRegForm = ({qr_code, setView, data, setData}) => {

    const API = new Api();
    const VALIDATOR = new Validator();
    const [stage, setStage] = useState("default");
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState("");

    if (qr_code !== undefined) {
        data.qr_code = qr_code;
    }


    const checkData = () => {
        var err = {};
        // validations
        if (stage === "default") {
            if (data.company_type === "") err.company_type = true;
            if (data.companyKw && data.contactPerson === "") err.contactPerson = true;
            if (data.name === "") err.name = true;
            if (data.company_type === "person" && data.lastName === "") err.lastName = true;
            if (!VALIDATOR.EmailValid(data.email)) err.email = "Ungültige E-Mail-Adresse";
            if (data.phone_country === "") err.phone_country = true;
            if (data.vorwahl === "") err.vorwahl = true;
            if (!VALIDATOR.IsNumeric(data.phone) || data.phone === "") err.phone = true;
            if (data.case === 6 && data.situation === "") err.situation = true;
        }

        // if there was errors return 
        if (Object.keys(err).length > 0) {
            return setErrors(err);
        }
        
        if (data.company_type === "company" && data.companyKw === true) {
            createTicket();
            setStage("loading");
        }
        if (data.company_type === "company" && data.companyKw === false && data.case !== 6) {
            registerUser();
        } 
        if ((data.company_type === 'person' && data.case === 6) || (data.company_type === 'company' && data.case === 6)) {
            setStage('upload');
        }
        if (data.company_type === "person" && data.case === 5) {
            registerUser()
        }
    }

    const createTicket = () => {
        var ticketData = {
            company_type: data.company_type,
            x_is_house_management: data.x_is_house_management,
            case: data.case,
            companyKw: data.companyKw,
            contactPerson: data.contactPerson,
            name: data.name + ` ${data.lastName}`,
            email: data.email,
            phone_country: "+43",
            vorwahl: "",
            phone: `${data.phone_country} ${data.vorwahl} ${data.phone}`,
            comment: data.comment,
            situation: data.situation,
            uploads: data.uploads,
        }
        API.register_bigcompany_contact(ticketData)
            .then(() => {
                setStage("ticket_done");
            })
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                setStage("error");
            });
    }

    const registerUser = () => {
        setStage("loading");
        let dataForSending = {...data};
        dataForSending.phone = `${data.phone_country} ${data.vorwahl} ${data.phone}`;
        API.register_basic(dataForSending)
            .then(() => {
                setStage("reg_done");
            })
            .catch(err => {
                if (err.response.data.detail) setApiError(err.response.data.detail);
                else setApiError("Unbekannter Fehler")
                setStage("error");
            })
    }


    return (
            <>
            {
                stage === "default"?
                    <InfoStage data={data} setData={setData} errors={errors} setErrors={setErrors} checkData={checkData} />

                : stage === "upload"?
                    <UploadStage data={data} setData={setData} setStage={setStage} setApiError={setApiError} />

                : stage === "upload_missing"?
                    <div className="text-start">
                        <h5 className="mt-3">E-Mail gesendet!</h5>
                        <p className="text-dark" style={{ fontSize: 14, fontWeight: 800 }}>
                            Vielen Dank für Ihr Interesse!
                            Wir haben Ihnen zur Erinnerung ein E-Mail gesendet.
                        </p>
                    </div>
                
                : stage === "loading"?
                    <div className="mt-5">
                        <h3>Ihre Daten werden übermittelt &nbsp;<Spinner animation="border" className="text-light" /></h3>
                    </div>

                : stage === "ticket_done"?
                    <div className="mt-5">
                        <h5>Kontaktaufnahme</h5>
                        <figure>
                            <blockquote className="blockquote">
                                {data.companyKw ?
                                    <p style={{fontSize: 14, fontWeight: 800, marginBottom: 20}} className="text-dark">
                                        Wir haben Ihre Daten erhalten und werden uns in Kürze bei Ihnen melden.
                                    </p>
                                    :
                                    <p className="text-dark">
                                        Wir haben Ihre Daten erfasst und werden uns in Kürze mit einem Vergleichsangebot bei Ihnen melden.
                                    </p>
                                }
                            </blockquote>
                            <figcaption className="blockquote-footer text-end text-light">
                                <b>Ihr ENERGO Team</b>
                            </figcaption>
                        </figure>
                    </div>

                : stage === "reg_done"?
                    <div className="mt-5">
                        <h5>ENERGO ENERGIEDIENSTLEISTUNGEN GmbH</h5>
                        <br />
                        <p style={{fontSize: 14, fontWeight: 800, marginBottom: 20}} className="text-light">
                            Vielen Dank für die Bekanntgabe Ihrer Daten! <br />
                            Wir haben Ihnen ein E-Mail gesendet, um Ihre E-Mail-Adresse
                            zu verifizieren.
                        </p>
                        <Row>
                            <Col className="text-center">
                                <Button variant="warning" onClick={() => setView('login')}>Verstanden</Button>
                            </Col>
                        </Row>
                    </div>

                : stage === "error"?
                    <div className="mt-5">
                        <Row>
                            <Col>
                                <h5 className="text-danger">Fehler aufgetreten</h5>
                                <p className="text-dark" style={{fontSize: 14, fontWeight: 800}}>{apiError}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-center">
                                <Button variant="warning" onClick={() => checkData()}>Nochmal versuchen</Button>
                            </Col>
                        </Row>
                    </div>
                
                : null
            }
        </>
    )
}
export default BasicRegForm;